import React, { PropsWithChildren, useCallback, useMemo, useState } from "react";

import { CircularProgress } from "@mui/material";

import { FullScreenBackdrop } from "@/common/components/backdrop/full-screen-backdrop/FullScreenBackdrop";

import LoadingIndicatorContext from "./LoadingIndicatorContext";

const LoadingIndicatorContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [loaders, setLoaders] = useState<number>(0);

  const withLoader = useCallback(async <T,>(request: Promise<T>): Promise<T> => {
    try {
      setLoaders((prev) => prev + 1);
      return await request;
    } finally {
      setLoaders((prev) => Math.max(prev - 1, 0));
    }
  }, []);

  // It guarantees the object reference is the same unless withLoader changes.
  const contextValue = useMemo(() => ({ withLoader }), [withLoader]);

  return (
    <>
      <LoadingIndicatorContext.Provider value={contextValue}>{children}</LoadingIndicatorContext.Provider>
      {loaders > 0 && (
        <FullScreenBackdrop>
          <CircularProgress color="inherit" />
        </FullScreenBackdrop>
      )}
    </>
  );
};

export default LoadingIndicatorContextProvider;
